export function isPhoneValidate(value) {
  return /^\d{5,15}$/.test(value)
}
export function isNonzeroStartMobile(value) {
  return /^[1-9]\d{4,14}$/.test(value)
}
export function isEmailValidate(value) {
  return /^[.\w-]+@[\w-]+(\.[\w-]+)+$/.test(value)
}
export function isInviteValidate(value) {
  return /\w{5}$/.test(value)
}

export function isPasswordValidate(value) {
  const num = /\d/.test(value)
  const upper = /[A-Z]/.test(value)
  const lower = /[a-z]/.test(value)
  const ugly = /[~`@#$%^&*()_\-+={}[\];:,<>.?/]/.test(value)
  if (value && value.length >= 8 && value.length <= 20) {
    const level = [num, upper, lower, ugly].reduce((acc, next) => {
      acc += +next
      return acc
    }, 0)
    return level >= 3
  }
  return false
}

export function isIPValidate(value) {
  const ipReg = /^((?:\d{1,3}\.){3}\d{1,3}(?:, ?|$)|(([0-9a-f]{1,4}:){7}[0-9a-f]{1,4})|(([0-9a-f]{1,4}:){6}:[0-9a-f]{1,4})|(([0-9a-f]{1,4}:){5}(:[0-9a-f]{1,4}){1,2})|(([0-9a-f]{1,4}:){4}(:[0-9a-f]{1,4}){1,3})|(([0-9a-f]{1,4}:){3}(:[0-9a-f]{1,4}){1,4})|(([0-9a-f]{1,4}:){2}(:[0-9a-f]{1,4}){1,5})|([0-9a-f]{1,4}:((:[0-9a-f]{1,4}){1,6}))|(:((:[0-9a-f]{1,4}){1,7})))$/i
  return ipReg.test(value)
}
